import { HttpError, NetworkError, UnauthorizedError, ValidationError } from '@alter/api-client';

/**
 * Dónde ocurrió el error. El mismo código HTTP significa cosas distintas
 * según la pantalla: un 401 en el login son credenciales inválidas, no una
 * sesión vencida; un 404 en `mi-simulacion` es "no hay nada agendado", no
 * una falla del servidor.
 */
export type ContextoError = 'general' | 'login' | 'mi_simulacion';

export const MENSAJES_ERROR = {
  credencialesInvalidas: 'Credenciales inválidas. Revisar el usuario y la contraseña.',
  sinSimulacion: 'No hay una simulación agendada. Contactar al equipo docente.',
  sesionVencida: 'La sesión expiró. Es necesario volver a ingresar.',
  sinConexion: 'Sin conexión. Revisar la red e intentar de nuevo.',
  formatoInesperado: 'La respuesta del servidor no tuvo el formato esperado.',
  inesperado: 'Ocurrió un error inesperado.',
} as const;

/**
 * Transforma un error capturado en un mensaje para mostrar en la UI.
 * Redacción impersonal (D-11 de la tanda 2), sin voseo, tuteo ni usted.
 * Los errores tipados de `@alter/api-client` ya vienen sanitizados.
 */
export function formatError(error: unknown, contexto: ContextoError = 'general'): string {
  if (error instanceof UnauthorizedError) {
    return contexto === 'login'
      ? MENSAJES_ERROR.credencialesInvalidas
      : MENSAJES_ERROR.sesionVencida;
  }
  if (error instanceof HttpError) {
    if (contexto === 'mi_simulacion' && error.status === 404) return MENSAJES_ERROR.sinSimulacion;
    return `Error del servidor (${String(error.status)}). Intentar más tarde.`;
  }
  if (error instanceof NetworkError) return MENSAJES_ERROR.sinConexion;
  if (error instanceof ValidationError) return MENSAJES_ERROR.formatoInesperado;
  if (error instanceof Error) return error.message;
  return MENSAJES_ERROR.inesperado;
}

/** `true` si el error de `mi-simulacion` significa "no hay nada agendado" (404). */
export function esSinSimulacion(error: unknown): boolean {
  return error instanceof HttpError && error.status === 404;
}
